<template>
    <div class="container-dots">
        <slot></slot>
        <div class="animatedDots"></div>
    </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
.container-dots {
    display: flex;
}
.animatedDots {
    width: 10px;
    text-align: initial;
    margin-left: 2px;
}
.animatedDots:after {
    animation: dotty steps(1,end) 1s infinite;
    content: '';
}
@keyframes dotty {
    0%   { content: ''; }
    25%  { content: '.'; }
    50%  { content: '..'; }
    75%  { content: '...'; }
    100% { content: ''; }
}
</style>
